(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jb-rebate-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rebate-carousel')) {
    customElements.define('rebate-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.controls = [...this.querySelectorAll('[data-go-to]')];
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = Number(this.dataset.speed) || 5000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.controls.forEach((control) => control.addEventListener('click', () => this.show(Number(control.dataset.goTo), true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          if (slide) this.show(Number(slide.dataset.slide), true);
        });
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(next, manual = false) {
        if (this.slides.length < 2) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.controls.forEach((control) => {
          const active = Number(control.dataset.goTo) === this.index;
          control.classList.toggle('is-active', active);
          control.setAttribute('aria-selected', String(active));
          if (active && control.classList.contains('jb-rebate__thumbnail')) {
            control.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
          }
        });
        if (manual) this.start();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.reducedMotion || this.slides.length < 2) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.speed);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  if (!customElements.get('cart-note')) customElements.define('cart-note', CartNote);

  class ShippingQuoteGate extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.province = this.querySelector('[data-quote-province]');
      this.postal = this.querySelector('[data-quote-postal]');
      this.guidance = this.querySelector('[data-quote-guidance]');
      this.quebec = this.querySelector('[data-quote-quebec]');
      this.outside = this.querySelector('[data-quote-outside]');
      this.checkout = this.querySelector('[data-quote-checkout]');
      this.form = this.querySelector('[data-quote-form]');
      this.status = this.querySelector('[data-quote-status]');
      this.submit = this.querySelector('[data-quote-submit]');
      this.submitLabel = this.querySelector('[data-quote-submit-label]');
      this.defaultSubmitLabel = this.submitLabel?.textContent || '';
      this.items = JSON.parse(this.querySelector('[data-quote-items]')?.textContent || '[]');
      this.restoreDestination();
      this.province?.addEventListener('change', () => this.update());
      this.postal?.addEventListener('input', () => this.update());
      this.form?.addEventListener('submit', (event) => this.requestQuote(event));
      this.update();
    }

    normalizePostal() {
      return (this.postal?.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
    }

    postalIsValid() {
      return /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTVWXYZ]\d[ABCEGHJ-NPRSTVWXYZ]\d$/.test(this.normalizePostal());
    }

    restoreDestination() {
      try {
        this.province.value = localStorage.getItem('jb_shipping_province') || '';
        this.postal.value = localStorage.getItem('jb_shipping_postal') || '';
      } catch (error) {
        this.province.value = '';
        this.postal.value = '';
      }
    }

    saveDestination() {
      try {
        localStorage.setItem('jb_shipping_province', this.province.value);
        localStorage.setItem('jb_shipping_postal', this.postal.value);
      } catch (error) {
        return;
      }
    }

    update() {
      const province = this.province?.value || '';
      const validPostal = this.postalIsValid();
      this.saveDestination();
      this.guidance.hidden = Boolean(province && validPostal);
      this.quebec.hidden = province !== 'QC' || !validPostal;
      this.outside.hidden = !province || province === 'QC' || !validPostal;
      this.checkout.disabled = this.dataset.cartEmpty === 'true' || province !== 'QC' || !validPostal;

      const quebecMessage = this.querySelector('[data-quote-quebec-message]');
      if (quebecMessage) {
        quebecMessage.textContent = this.dataset.freeShipping === 'true'
          ? this.dataset.quebecFree
          : this.dataset.quebecPaid;
      }

      if (province && !validPostal && this.normalizePostal().length >= 6) {
        this.setStatus(this.dataset.invalidPostal, 'error');
      } else if (!this.submit?.disabled) {
        this.setStatus('', '');
      }
    }

    setStatus(message, type) {
      this.status.textContent = message || '';
      this.status.classList.toggle('is-error', type === 'error');
      this.status.classList.toggle('is-success', type === 'success');
    }

    async requestQuote(event) {
      event.preventDefault();
      if (!this.postalIsValid()) {
        this.setStatus(this.dataset.invalidPostal, 'error');
        this.postal.focus();
        return;
      }
      if (!this.form.reportValidity()) return;

      this.submit.disabled = true;
      this.submitLabel.textContent = this.submit.dataset.sending || '…';
      this.setStatus('', '');

      const requestFingerprint = JSON.stringify({
        province: this.province.value,
        postalCode: this.normalizePostal(),
        items: this.items,
      });
      let requestId = sessionStorage.getItem('jb_shipping_quote_request_id');
      const savedFingerprint = sessionStorage.getItem('jb_shipping_quote_fingerprint');
      if (!requestId || savedFingerprint !== requestFingerprint) {
        requestId = crypto.randomUUID();
        sessionStorage.setItem('jb_shipping_quote_request_id', requestId);
        sessionStorage.setItem('jb_shipping_quote_fingerprint', requestFingerprint);
      }

      const payload = {
        requestId,
        name: this.querySelector('[data-quote-name]').value,
        email: this.querySelector('[data-quote-email]').value,
        phone: this.querySelector('[data-quote-phone]').value,
        company: this.querySelector('[data-quote-company]').value,
        province: this.province.value,
        postalCode: this.normalizePostal(),
        items: this.items,
      };

      try {
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const result = await response.json();
        if (!response.ok || !result.ok) throw new Error(result.error || 'request_failed');
        const message = this.dataset.successTemplate.replace('__REFERENCE__', result.reference || '');
        this.setStatus(message, 'success');
        this.form.hidden = true;
      } catch (error) {
        this.setStatus(this.dataset.errorMessage, 'error');
        this.submit.disabled = false;
        this.submitLabel.textContent = this.defaultSubmitLabel;
      }
    }
  }

  if (!customElements.get('shipping-quote-gate')) customElements.define('shipping-quote-gate', ShippingQuoteGate);

  } catch(e) { console.error(e); }
})();
})();
